"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmbedAreas = exports.EmbedPlacement = void 0;
var EmbedPlacement;
(function (EmbedPlacement) {
    EmbedPlacement["CaseworkerWebCreditorPage"] = "CASEWORKER_WEB_CREDITOR_PAGE";
    EmbedPlacement["CaseworkerWebCasePage"] = "CASEWORKER_WEB_CASE_PAGE";
    EmbedPlacement["CaseworkerWebMenuItem"] = "CASEWORKER_WEB_MENU_ITEM";
    EmbedPlacement["CreditorWebCasePage"] = "CREDITOR_WEB_CASE_PAGE";
    EmbedPlacement["CreditorWebMenuItem"] = "CREDITOR_WEB_MENU_ITEM";
    EmbedPlacement["CreditorWebFrontPage"] = "CREDITOR_WEB_FRONT_PAGE";
})(EmbedPlacement || (exports.EmbedPlacement = EmbedPlacement = {}));
const getEmbedAreas = (embeds, embedPlacement) => {
    const areas = Object.values(embeds).reduce((acc, arr) => acc.concat(arr), []);
    return embedPlacement
        ? areas.filter((area) => area.placement === embedPlacement)
        : areas;
};
exports.getEmbedAreas = getEmbedAreas;
//# sourceMappingURL=index.js.map